<template lang="pug">
  div.mt-1
    modal-editar-oficio(
      :documentoId="oficio.id"
      v-if="!oficio.protocolo && showModalEditarOficio"
      :oficio="oficio"
      :titulo="'Editar Ofício'",
      @closeModal="closeModalEditarOficio"
      @onUpdatePDF="onUpdatePDF"
      )
    div(v-if="bytes")
      app-pdf-viewer(:bytes="bytes")
    div.mt-1
      el-button(
        @click="showModal"
        v-if="showEditar()"
        ).align
        i.fal.fa-file-pdf
        span &nbsp Editar ofício
</template>

<script>
import { mapActions } from 'vuex'
import ModalEditarOficio from '@/screens/arrecadacao/cpat/components/ModalEditarOficio'
import AppPdfViewer from '@/components/AppPDFViewer'

export default {
  components: {
    AppPdfViewer,
    ModalEditarOficio
  },

  props: {
    oficio: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      bytes: null,
      showModalEditarOficio: false
    }
  },
  methods: {
    ...mapActions({
      getPDFMatricula: 'oficioArrecadacao/getPDFMatricula',
      emitirPortaria: 'portariaArrecadacao/emitirPortaria'
    }),
    showEditar () {
      return !this.oficio.protocolo && this.oficio.processo.status !== 'EM_EMISSAO_MINUTAS' && this.oficio.processo.status !== 'AGUARDANDO_EMISSAO_PORTARIA'
    },
    closeModalEditarOficio () {
      this.showModalEditarOficio = false
    },

    showModal () {
      this.showModalEditarOficio = true
    },

    async renderPDF () {
      var bytes
      if (this.oficio.processo.status === 'AGUARDANDO_MINUTA_MATRICULA') {
        bytes = await this.getPDFMatricula(this.oficio.id)
      } else {
        bytes = await this.emitirPortaria(this.oficio.processo.id)
      }
      this.bytes = bytes

      this.$emit('getBytesPdf', bytes)
    },

    async onUpdatePDF (val) {
      await this.renderPDF()
      this.closeModalEditarOficio()
    }
  },

  mounted () {
    this.renderPDF()
  }
}
</script>

<style lang="scss">
.align {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/cpat/components/matricula/ConfirmarMatricula.vue